import React from 'react';
import {FmlxButton} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import './LoadingView.scss';

function LoadingView({show, text, mode, darkMode, hideLogo, onCancel}) {
  return (
    <div className={`fmlx-loading-view ${show ? 'show' : 'hide'} ${mode}`}>
      <img
        className="fmlx-loading-animation"
        src={`./svg/loading/loading${darkMode ? '-black' : ''}.gif`}
        alt="loading"
      />
      <div className="fmlx-loading-text">{text}</div>
      {onCancel && (
        <div className="fmlx-cancel-button">
          <FmlxButton
            label="Cancel"
            type="danger"
            size="xl"
            onClick={() => {
              onCancel();
            }}
            darkMode={darkMode}
          />
        </div>
      )}
      {!hideLogo && <img className="fmlx-loading-logo" src="./svg/loading/formulatrix.svg" alt="formulatrix logo" />}
    </div>
  );
}

export default LoadingView;

LoadingView.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.any,
  mode: PropTypes.oneOf(['FullScreen', 'Contained']),
  darkMode: PropTypes.bool,
  hideLogo: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

LoadingView.defaultProps = {
  show: true,
  text: 'loading...',
  mode: 'FullScreen',
  darkMode: false,
  hideLogo: false,
};
